module.exports = __webpack_public_path__ + "d26f5b38ce6384d3c8c81bb003d5659b.svg";